import { cn } from '../lib/cn';

export function Card({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'rounded-xl bg-paper-elevated p-6 shadow-[0_1px_2px_0_rgba(0,0,0,0.4)]',
        className
      )}
    >
      {children}
    </div>
  );
}
